export default (
  state = {
    domains: [],
    suggestion: null,
    signupMethod: "",
    email: "",
    subDomainName: "",
  },
  action,
) => {
  switch (action.type) {
    case "UPDATE_ORG_SETTINGS":
      return {
        ...state,
        domains: action.payload.domains,
        suggestion: action.payload.suggestion,
        signupMethod: action.payload.signupMethod,
      };
    case "SET_DATA_FOR_RESET_PASSWORD":
      return {
        ...state,
        email: action.payload.email,
        subDomainName: action.payload.subDomainName,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js